import { render, staticRenderFns } from "./LearningList.vue?vue&type=template&id=6be9fb7a"
import script from "./LearningList.vue?vue&type=script&lang=js"
export * from "./LearningList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports